import { render, staticRenderFns } from "./ListTagPage.vue?vue&type=template&id=d11c4768&"
import script from "./ListTagPage.vue?vue&type=script&lang=js&"
export * from "./ListTagPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports